<template>
    <el-table
        :data="arr"
        style="width: 100%">
        <el-table-column
            prop="trade_time"
            label="交易日期"
            width="180">
        </el-table-column>
        <el-table-column
            prop="account_number"
            label="银行账号"
            width="180">
        </el-table-column>
        <el-table-column
            prop="account_name"
            label="银行账户名称"
            width="180">
        </el-table-column>
        <el-table-column
            prop="duifangxinxi"
            label="对方信息">
        </el-table-column>
        <el-table-column
            prop="zhichu_amount"
            label="支出金额">
        </el-table-column>
        <el-table-column
            prop="shouru_amount"
            label="收入金额">
        </el-table-column>
        <el-table-column
            prop="balance_amount"
            label="余额">
        </el-table-column>
        <el-table-column
            prop="trade_way"
            label="交易方式">
        </el-table-column>
        <el-table-column
            prop="trade_transact"
            label="交易往来">
        </el-table-column>
        <el-table-column
            prop="trade_channel"
            label="交易渠道">
        </el-table-column>
        <el-table-column
            prop="trade_remark"
            label="交易说明">
        </el-table-column>
    </el-table>
</template>
<script>
    export default {
        props: {
            arr: {
                type: Array,
                default: _ => []
            }
        }
    }
</script>
